module.exports = __webpack_public_path__ + "img/floppy-disk-pen.9c556f4a.svg";